import React from 'react';
import { ExternalLink } from 'components';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './CookieConsent.module.scss';

export const CookieConsent = () => {
    const cmp = window.__cmp;
    if (!cmp) {
        return null;
    }

    const openConsentPopup = () => {
        cmp('showScreenAdvanced');
    };

    return (
        <ExternalLink onClick={openConsentPopup} className={styles['container']}>
            <FormattedMessage id="app.legal.cookieConsent" defaultMessage="Cookie Consent" />
        </ExternalLink>
    );
};
